import { render } from "./IntroSimp.vue?vue&type=template&id=8e116376&scoped=true"
import script from "./IntroSimp.vue?vue&type=script&lang=js"
export * from "./IntroSimp.vue?vue&type=script&lang=js"

import "./IntroSimp.vue?vue&type=style&index=0&id=8e116376&lang=scss&scoped=true"

import exportComponent from "/Users/jaxz/Desktop/wangyan-campaign/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e116376"]])

export default __exports__